import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

const About = () => {
  const data = [
    { image:"https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=1331&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Our vision goes beyond aesthetics—we aim to design spaces that remain relevant and functional.",
      keypoints: ['Enduring Vision', 'Sustainable Focus', 'Precision & Detail', 'Future-Ready']
    },
    { image:"https://images.unsplash.com/photo-1612935089040-89195ef54677?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Architecture is more than structures—it's about enhancing how people live, work, and connect.",
      keypoints: ['Functional Flow', 'People-Centered', 'Inspired Living', 'Comfort First']
    },
    { image:"https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      title: "Ka Construction  is built on a foundation of artistry and craftsmanship for the modern world.",
      keypoints: ['Creative Roots', 'Craftsmanship', 'Design Legacy', 'Trusted Excellence']
    },
  ];

  const [active, setActive] = useState(0);

  // Fixed useEffect - properly handles interval and cleanup
  useEffect(() => {
    const interval = setInterval(() => {
      setActive(prev => (prev === data.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [data.length]);

  const handleTabClick = (index) => {
    setActive(index);
  };

  return (
    <section id="about" className="py-20 px-5 lg:px-32 bg-gray-50">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch"> {/* Changed to items-stretch */}
          
          {/* Left Column - Image with fixed height */}
          <div className="relative h-full"> {/* Added h-full */}
            <div className="overflow-hidden rounded-xl shadow-xl h-[620px]">
              <img 
                src={data[active].image} 
                alt="Modern architecture design"
                className="rounded-xl w-full h-full object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
            {/* Badge */}
           
          </div>

          {/* Right Column - Content with matching height */}
          <div className="h-full flex flex-col"> {/* Added h-full and flex-col */}
            {/* Tagline */}
            <div className="mb-4">
              <span className="text-sm font-semibold text-yellow-600 bg-yellow-50 px-3 py-1 rounded-full">
                INNOVATIVE DESIGN
              </span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
              Redefining the Future of Design
            </h2>
            
            <p className="text-gray-600 mb-8">
              BuildMasters Construction is a family-owned business that has been delivering exceptional 
              construction services for over two decades. Our commitment to quality, safety, and customer 
              satisfaction has made us a trusted name in the industry.
            </p>
            
            {/* Tab Navigation */}
            <div className="mb-8 flex space-x-3">
              {["Our Objective", "Our Goal", "Our Mission"].map((label, index) => (
                <button
                  key={index}
                  onClick={() => handleTabClick(index)}
                  className={`px-4 py-2 rounded-lg font-medium transition-all ${
                    active === index
                      ? "bg-yellow-600 text-white shadow"
                      : "bg-white text-gray-700 border border-gray-300 hover:border-yellow-400"
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>
            
            {/* Content Area - Takes remaining space */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex-grow"> {/* Added flex-grow */}
              <p className="text-lg text-gray-800 mb-6 font-medium">
                {data[active].title}
              </p>
              
              <div className="space-y-4">
                {data[active].keypoints.map((item, index) => (
                  <div key={index} className="flex items-center">
                    <div className="w-8 h-8 flex items-center justify-center mr-3">
                      <FontAwesomeIcon 
                        icon={faStar} 
                        className="text-yellow-500"
                      />
                    </div>
                    <p className="text-gray-700">{item}</p>
                  </div>
                ))}
              </div>
              
             
            </div>

            
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;